import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {
    AuthenticationService,
    BreadcrumbNavigationService,
    ConfigurationService,
    CoursesService,
    PortalConfigurationService,
    RestApiService
} from '@draeger-academy/common';
import { CartService } from '@draeger-academy/common/lib/services/cart/cart.service';
import { GenericModalService } from '@draeger-academy/presentation/lib/modules/generic-modal';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Course } from '../../../../../../models/course';
import { Training } from '../../../../../../models/training';
import { TrainingDescription } from '../../../../../../models/training-description';
import { Paragraph } from '../../../../../../models/paragraph';

import { HttpClient } from '@angular/common/http';
import { CartItem } from 'models/cartItem';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';

@Component({
    selector: 'da-course-detail',
    templateUrl: './course-detail.component.html',
    styleUrls: ['./course-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CourseDetailComponent implements OnInit {
    public site: string;
    public isPortal = false;
    public description: any;
    private _subscription: Subscription;
    private _courseSub: Subscription;
    private _modalId: string;
    private _$course: BehaviorSubject<Course> = new BehaviorSubject<Course>(null);
    private _$similarCourses: BehaviorSubject<Course[]> = new BehaviorSubject<Course[]>(null);
    private _$isString: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    private _$tabSection: BehaviorSubject<object> = new BehaviorSubject(null);
    private _$showDownload: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _$showCartUpdate: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _$showSimilarCourses: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public downloadDescriptionLink: string;
    public courseImage;
    public logo = '';
    public learningGoals: string;
    public eventsNorth: Array<CartItem>;
    public eventsEast: Array<CartItem>;
    public eventsSouth: Array<CartItem>;
    public eventsWest: Array<CartItem>;
    public citiesNorth: Array<string>;
    public citiesEast: Array<string>;
    public citiesSouth: Array<string>;
    public citiesWest: Array<string>;
    public eventDuration: number;
    public courseUrl: string;
    public courseUrlPrint: string;
    public qrCodeDownloadLink = '';
    public learningGoalsText: Array<Paragraph>;
    public targetGroupText: Array<Paragraph>;
    public courseContentText: Array<Paragraph>;
    public learningGoalsTitle: string;
    public targetGroupTitle: string;
    public courseContentTitle: string;
    public noteTextTitle: string;
    public requirementsTitle: string;
    public noteText: Array<Paragraph>;
    public requirementsText: Array<Paragraph>;
    public training: Training;
    public trainingDescriptions: Array<TrainingDescription>;
    public paragraph: Array<Paragraph>;
    public events: Array<CartItem>;
    public portalCountry: string;
    public eventNumber: number;
    public isBookedCourse = false;
    public isLoggedIn: boolean;
    public portalId: string;
    public language: string;
    public course: Course;
    public currency: string;
    public isPlusPortSite = false;

    @ViewChild('pdfCourse')
    pdfCourse: ElementRef;

    private _$courseImage: BehaviorSubject<{}> = new BehaviorSubject<{}>(null);
    public get courseImage$(): Observable<{}> {
        return this._$courseImage.asObservable();
    }

    constructor(
        private sanitizer: DomSanitizer,
        private route: ActivatedRoute,
        private _coursesService: CoursesService,
        private _restApiService: RestApiService,
        private _breadcrumbNavigationService: BreadcrumbNavigationService,
        private _configurationService: ConfigurationService,
        private _cartService: CartService,
        private _genericModalService: GenericModalService,
        private _translateService: TranslateService,
        private http: HttpClient,
        private authenticationService: AuthenticationService,
        private _router: Router,
        private _localizeRouterService: LocalizeRouterService,
        private _portalConfigurationService: PortalConfigurationService
    ) {}

    public get showCartUpdate$(): Observable<boolean> {
        return this._$showCartUpdate.asObservable();
    }

    public get course$(): Observable<Course> {
        return this._$course.asObservable();
    }

    public get similarCourse$(): Observable<Course[]> {
        return this._$similarCourses.asObservable();
    }

    public get isString$(): Observable<boolean> {
        return this._$isString.asObservable();
    }

    public get showDownload$(): Observable<boolean> {
        return this._$showDownload.asObservable();
    }

    public get tabSection$(): Observable<object> {
        return this._$tabSection.asObservable();
    }

    public get showSimilarCourses$(): Observable<boolean> {
        return this._$showSimilarCourses.asObservable();
    }

    private _$showVat: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showVat$(): Observable<boolean> {
        return this._$showVat.asObservable();
    }

    private _$dateFormat: BehaviorSubject<string> = new BehaviorSubject('');
    public get dateFormat$(): Observable<string> {
        return this._$dateFormat.asObservable();
    }

    private _$pricePattern: BehaviorSubject<string> = new BehaviorSubject('');
    public get pricePattern$(): Observable<string> {
        return this._$pricePattern.asObservable();
    }
    private _$formattedPrice: BehaviorSubject<string> = new BehaviorSubject('');
    public get formattedPrice$(): Observable<string> {
        return this._$formattedPrice.asObservable();
    }
    private _$formattedPrice2: BehaviorSubject<string> = new BehaviorSubject('');
    public get formattedPrice2$(): Observable<string> {
        return this._$formattedPrice2.asObservable();
    }

    onChangeURL(url) {
        this.qrCodeDownloadLink = url;
    }

    ngOnInit(): void {
        this.site = this._configurationService.getCurrentSite();
        if (this._configurationService.isPartnerPage()) {
            this.isPortal = true;
        }
        this.checkIfItIsPlusPortSite();

        this.authenticationService.loggedIn().subscribe((data) => {
            if (data) {
                this.isLoggedIn = true;
            } else {
                this.isLoggedIn = false;
            }
        });
        this.courseUrl = window.location.href;
        this.courseUrlPrint = this.courseUrl.replace('https://', '');
        this.courseUrlPrint = this.courseUrlPrint.replace('http://', '');
        this.logo = environment.locales + 'assets/images/logo.svg';
        // this._breadcrumbNavigationService.setInitialCourseBreadcrumb();
        this.getCourse();
        this._courseSub = this.course$.subscribe((course) => {
            if (course && this._subscription) {
                this._coursesService.getNumberOfCourses().then((numberOfCourses) => {
                    this._breadcrumbNavigationService.updateCourseBreadcrumb(course, numberOfCourses.count);
                });
                if (course.image && course.image.uri) {
                    let courseImage = environment.APIEndpoint + course.image.uri.substr(course.image.uri.indexOf('/') + 1);
                    courseImage = encodeURI(courseImage);
                    this.courseImage = courseImage;
                    this._$courseImage.next(courseImage);
                    // this.imageUrlToBase64(courseImage).subscribe((base64) => {
                    //     courseImage = base64;
                    //     this._$courseImage.next(courseImage);
                    // });
                }
                try {
                    const desc = JSON.parse(course.training.description);
                    this._$isString.next(false);
                    this.description = desc;
                } catch {
                    if (course.training && course.training.description && typeof course.training.description === 'string') {
                        this._$isString.next(true);
                        this.description = course.training.description;
                    }
                }
                this.events = this._$course.getValue().events;
                this.eventNumber = this._$course.getValue().events.length;
                const events = this._$course.getValue().events;
                this.eventsFilteredByCostcenter(events);
                this.createEventDaysandTimes(events);
                this.course = course;
                this.currency = this._coursesService.getCurrencies(this.course, this.site);
                this.formatingPrice();
            }
        });

        this._restApiService.requestGET<any>('/assets/mock/tabsection_data.json').then((data: any) => {
            this._$tabSection.next(data);
        });

        this._$showDownload.next(true);
        this._$showSimilarCourses.next(this._configurationService.hasFeature('ShowSimilarCourses'));
    }

    // ngOnDestroy() {
    //     this._subscription.unsubscribe();
    //     this._courseSub.unsubscribe();
    //     localStorage.setItem('scrolly', window.pageYOffset.toString());
    // }

    getCourse() {
        this._subscription = this.route.params.subscribe((param) => {
            const _courseId = param['id'];
            const _site = this._configurationService.getCurrentSite();
            this.site = _site;

            let params = '';
            const ID = sessionStorage.getItem(`myCourseID`);
            if (ID === _courseId) {
                this.isBookedCourse = true;
            } else {
                this.isBookedCourse = false;
            }
            if (this._configurationService.isPartnerPage()) {
                this.isPortal = true;
                this._configurationService.currentPortal$.subscribe((portalId) => {
                    if (portalId) {
                        this.portalId = portalId;
                        const temp = portalId.toLocaleUpperCase().split('-').join('_');
                        params = `?portalName=${temp}`;
                    }
                });
                this._configurationService.getConfigPartnerByPortal().then((data) => {
                    this.portalCountry = data.filter((f) => f.key.toLowerCase() === 'countries')[0].value[0].code.toLowerCase();
                    if (!this.isBookedCourse) {
                        this._coursesService.getPortalCourseById(_courseId, this.portalCountry).then(
                            (course) => {
                                if (course.error) {
                                    console.log(course.error);
                                } else {
                                    this.actionsAfterPortalGettingCourse(course);
                                }
                            },
                            (error) => {
                                console.log(error);
                            }
                        );
                    } else if (this.isBookedCourse && this.isLoggedIn) {
                        this._coursesService.getBookedPortalCourseById(_courseId, this.portalCountry).then(
                            (course) => {
                                this.actionsAfterPortalGettingCourse(course);
                            },
                            (error) => {
                                console.log(error);
                            }
                        );
                    } else {
                        this._router.navigate(['/partner/' + this.portalId + '/account']);
                    }
                });
                this._portalConfigurationService.portalPreferences$.subscribe((preferences) => {
                    if (preferences) {
                        const _dateFormat = this._portalConfigurationService.getPortalDateFormat(preferences);
                        this._$dateFormat.next(_dateFormat);
                    }
                });
            } else {
                params = `?countryCode=${_site}`;
                if (!this.isBookedCourse) {
                    this._coursesService.getCourseById(_courseId).then(
                        (course) => {
                            this.actionsAfterGettingCourseForWebsite(course);
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
                } else if (this.isBookedCourse && this.isLoggedIn) {
                    this._coursesService.getBookedCourseById(_courseId).then(
                        (course) => {
                            this.actionsAfterGettingCourseForWebsite(course);
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
                } else {
                    const translatedPath: any = this._localizeRouterService.translateRoute('/login');
                    this._router.navigate([translatedPath], { skipLocationChange: true }).then(() => {});
                }
                this._$dateFormat.next('dd.MM.yyyy');
            }
            this.downloadDescriptionLink = `${environment.APIEndpoint}api/v1/course/getcoursedescription/${_courseId}${params}`;
        });
    }

    public goToCart() {
        this._$showCartUpdate.next(false);
        this.closeModal();
        this._cartService.goToCart();
    }

    public closeModal() {
        if (this._modalId) {
            this._genericModalService.close(this._modalId);
        }
    }

    public printPDFCourse() {
        window.print();
    }

    eventsFilteredByCostcenter(events) {
        this.eventsNorth = [];
        this.eventsEast = [];
        this.eventsSouth = [];
        this.eventsWest = [];
        events.forEach((element: CartItem) => {
            if (element.costCenterCode === 'TC-DEN' || element.costCenterCode === 'AC-SD') {
                this.eventsNorth.push(element);
            } else if (element.costCenterCode === 'TC-DEO') {
                this.eventsEast.push(element);
            } else if (element.costCenterCode === 'TC-DES') {
                this.eventsSouth.push(element);
            } else if (element.costCenterCode === 'TC-DEW') {
                this.eventsWest.push(element);
            }
        });
        this.citiesNorth = this.listForCities(this.eventsNorth);
        this.citiesEast = this.listForCities(this.eventsEast);
        this.citiesSouth = this.listForCities(this.eventsSouth);
        this.citiesWest = this.listForCities(this.eventsWest);
    }

    listForCities(events) {
        const cities: Array<string> = [];
        events.forEach((element: CartItem) => {
            if (cities.indexOf(element.location.city) === -1) {
                cities.push(element.location.city);
            }
        });
        return cities;
    }

    createEventDaysandTimes(events) {
        if (events && events.length > 0) {
            const event = events[0];
            const d1 = new Date(event.endDateTime);
            const d2 = new Date(event.beginDateTime);
            this.eventDuration = this.daysDiff(d2, d1);
        }
    }

    public secondsDiff(d1, d2) {
        const secDiff = Math.floor((d2 - d1) / 1000);
        return secDiff;
    }

    public minutesDiff(d1, d2) {
        const seconds = this.secondsDiff(d1, d2);
        const minutesDiff = Math.floor(seconds / 60);
        return minutesDiff;
    }

    public hoursDiff(d1, d2) {
        const minutes = this.minutesDiff(d1, d2);
        const hoursDiff = Math.floor(minutes / 60);
        return hoursDiff;
    }

    public daysDiff(d1, d2) {
        const hours = this.hoursDiff(d1, d2);
        const daysDiff = Math.ceil(hours / 24);
        return daysDiff;
    }

    public findDescriptionParagraphs() {
        this.training = this._$course.getValue().training;
        this.setCourseDescription();
        this._coursesService.languageSelected.subscribe((language) => {
            this.setCourseDescription();
        });

        if (this.trainingDescriptions) {
            this.trainingDescriptions.forEach((desc: TrainingDescription) => {
                if (desc.name === 'ZIELE1') {
                    this.learningGoalsTitle = desc.title;
                    this.learningGoalsText = desc.paragraphs;
                } else if (desc.name === 'TEILNEHMER') {
                    this.targetGroupTitle = desc.title;
                    this.targetGroupText = desc.paragraphs;
                } else if (desc.name === 'INHALT') {
                    this.courseContentTitle = desc.title;
                    this.courseContentText = desc.paragraphs;
                    this.stylingForTitles(this.courseContentText);
                } else if (desc.name === 'HINWEIS') {
                    this.noteTextTitle = desc.title;
                    this.noteText = desc.paragraphs;
                } else if (desc.name === 'VORAUSSETZUNG') {
                    this.requirementsTitle = desc.title;
                    this.requirementsText = desc.paragraphs;
                }
            });
        }
    }

    public stylingForTitles(contentText) {
        contentText.forEach((paragraph: Paragraph) => {
            paragraph.text = paragraph.text.replace(':', '');
        });
        this.courseContentText = contentText;
    }

    public actionsAfterPortalGettingCourse(course) {
        if (course) {
            this._$course.next(course);
            this.findDescriptionParagraphs();
            if (this.route.queryParams) {
                this._subscription = this.route.queryParams.subscribe((parameter) => {
                    const isDates = Boolean(parameter['dates']) ? true : false;
                    if (isDates) {
                        setTimeout(() => {
                            const tabSecond = <HTMLElement>document.querySelector('.tab-section .tabs-wrapper .tabs li:last-of-type');
                            tabSecond.click();
                            setTimeout(() => {
                                window.scrollTo(0, Number(localStorage.getItem('scrolly')));
                            }, 100);
                        }, 100);
                    }
                });
            }
        }
    }

    public actionsAfterGettingCourseForWebsite(course) {
        if (course) {
            this._$course.next(course);
            this.findDescriptionParagraphs();
            if (this._configurationService.hasFeature('ShowSimilarCourses')) {
                this._coursesService.getSimilarCourses(course.id).then((data) => {
                    if (data) {
                        this._$similarCourses.next(data);
                    }
                });
            }

            if (this.route.queryParams) {
                this._subscription = this.route.queryParams.subscribe((parameter) => {
                    const isDates = Boolean(parameter['dates']) ? true : false;
                    if (isDates) {
                        setTimeout(() => {
                            const tabSecond = <HTMLElement>document.querySelector('.tab-section .tabs-wrapper .tabs li:last-of-type');
                            tabSecond.click();

                            setTimeout(() => {
                                window.scrollTo(0, Number(localStorage.getItem('scrolly')));
                            }, 100);
                        }, 100);
                    }
                });
            }
        }
    }

    private setCourseDescription() {
        this.trainingDescriptions = this.training.trainingDescriptions;

        const site = this._configurationService.getSiteFromUrl();
        if (site) {
            this.site = site.site;
            this.language = this.site.split('_')[0];
        }
        if (this._configurationService.isPartnerPage()) {
            this.language = JSON.parse(sessionStorage.getItem('portalLang'))?.lang;
            this.site = JSON.parse(sessionStorage.getItem('portalLang'))?.portalId;
        }
        const newDescription = [];

        if (this.trainingDescriptions && this.trainingDescriptions.length > 0) {
            for (const desc of this.trainingDescriptions) {
                if (desc.languageKey === this.language) {
                    newDescription.push(desc);
                }
            }
            if (newDescription.length === 0) {
                for (const desc of this.trainingDescriptions) {
                    if (desc.languageKey === this._$course.getValue().language) {
                        newDescription.push(desc);
                    }
                }
            }
            this.trainingDescriptions = newDescription;
        }
    }
    private formatingPrice(){      
        if (this._configurationService.isPartnerPage()) {
                this._portalConfigurationService.currencyPattern$.subscribe((currencyPattern) => {
                    this._$formattedPrice.next(this.formatPrice(this.course.prices[0].value, currencyPattern));
                    if (this.course.prices[1]){
                        this._$formattedPrice2.next(this.formatPrice(this.course.prices[1].value, currencyPattern));
                    }
                });

            this._translateService.stream('common').subscribe((translation) => {
                if (translation && translation.currency) {

                    if (translation.currency.ShowVATPrice === 'true') {
                        this._$showVat.next(true);
                    }
                }
            });
        } else {
            this._$pricePattern.next('#.##0,00 " $"');
            if (this.site === 'en_uk' || this.site === 'en_nz' || this.site === 'en_au' || this.site === 'fr_fr') {
                this._$pricePattern.next('#,##0.00 " $"');
            }

            if (this.course.prices.length > 0) {
                this._$formattedPrice.next(this.formatPrice(this.course.prices[0].value, this._$pricePattern.getValue()));
                if (this.course.prices[1]){
                    this._$formattedPrice2.next(this.formatPrice(this.course.prices[1].value, this._$pricePattern.getValue()));
                }
            } else {
                if (this.course.price){
                    this._$formattedPrice.next(this.formatPrice(this.course.price, this._$pricePattern.getValue()));
                }
            }           
            if (this._configurationService.hasFeature('ShowVATPrice')) {
                this._$showVat.next(true);
            }
        }
    }



    private formatPrice(price: any, formatPattern){
        if (formatPattern){
            return this._configurationService.formatPrice(price, formatPattern, this.currency);
        } else {
            return price;
        }
    }

    decodeHtml(description) {
        let descriptionLong = document.createElement("textarea");
        descriptionLong.innerHTML = description;
        return descriptionLong.value;
    }

    private checkIfItIsPlusPortSite() {
        if (!this.isPortal && (this.site === 'en_uk' || this.site === 'en_nz' || this.site === 'en_au' || this.site === 'fr_fr')) {
            this.isPlusPortSite = true;
        } else {
            this.isPlusPortSite = false;
        }
    }
}
